var render, staticRenderFns
import script from "./TransitionExpand.vue?vue&type=script&lang=js"
export * from "./TransitionExpand.vue?vue&type=script&lang=js"
import style0 from "./TransitionExpand.vue?vue&type=style&index=0&id=c0c85402&prod&scoped=true&lang=css"
import style1 from "./TransitionExpand.vue?vue&type=style&index=1&id=c0c85402&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0c85402",
  null
  
)

export default component.exports